import { CartDto, CartDtoVatTypeEnum } from '../../../generated-api';

export const createEmptyCart = (
  locationId: string,
  defaultVatType: CartDtoVatTypeEnum = CartDtoVatTypeEnum.EAT_IN
): CartDto => ({
  orderLines: [],
  created: new Date().toISOString(),
  updated: new Date().toISOString(),
  status: 'OPEN',
  totalPrice: 0,
  totalTakeawayPrice: 0,
  locationId,
  vatType: defaultVatType,
  comment: undefined,
});

export const clearCartFromStorage = (locationId: string, storage?: Storage) => {
  storage?.removeItem(`cart_${locationId}`);
};

export const updateCartInStorage = (cart: CartDto, locationId: string, storage?: Storage) => {
  storage?.setItem(`cart_${locationId}`, JSON.stringify(cart));
};

export const getCartFromStorage = (
  locationId: string,
  storage?: Storage,
  defaultVatType: CartDtoVatTypeEnum = CartDtoVatTypeEnum.EAT_IN
): CartDto => {
  if (!storage) {
    return createEmptyCart(locationId, defaultVatType);
  }

  const cartJson = storage.getItem(`cart_${locationId}`);

  if (!cartJson) {
    return createEmptyCart(locationId, defaultVatType);
  }

  const cart = JSON.parse(cartJson);

  const cartCreated = new Date(cart.created);

  const now = new Date();
  const diff = now.getTime() - cartCreated.getTime();
  const diffHours = diff / (1000 * 60 * 60); // 24 hours

  if (diffHours > 24) {
    clearCartFromStorage(locationId, storage);
    return createEmptyCart(locationId, defaultVatType);
  }

  return cart;
};
